import React, { useContext, useState, useEffect } from "react";
import { EmplContext } from "../../Login_Page/Login_Page/LoginPage";
import "./LeaveTable.css";
import { ColorContext } from "../../../ColorContext";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import configData from "../../../../src/config.json";
import Swal from "sweetalert2";
import {
  parseLeaveResult,
  showLeaveError,
  showLeaveCatch,
} from "../../../../src/utils/leaveAlert";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LoadingComponent from "../../loading_component";
import { 
  FileEarmarkText, 
  FileEarmarkPdf, 
  Image,
  Download,
  Trash
} from 'react-bootstrap-icons';

const LeaveTable = () => {
  const { resultData } = useContext(EmplContext);
  const employee_id = resultData.employee_id || 0;
  const [load, setLoading] = useState(false);
  const [leaves, setLeaves] = useState([]);
  const { bgColor, textColor } = useContext(ColorContext);
  const [selectedRow, setSelectedRow] = useState(null);
  const [show, setShow] = useState(false);
  const [showleave, setShowLeave] = useState(false);
  const [showReapply, setShowReapply] = useState(false);
  const [formData, setFormData] = useState({
    attachment: null,
  });

  // State for reapply modal
  const [editDescription, setEditDescription] = useState("");
  const [existingAttachments, setExistingAttachments] = useState([]);
  const [attachmentsToRemove, setAttachmentsToRemove] = useState([]);
  const [newAttachments, setNewAttachments] = useState([]);

  const handleClose = () => {
    setShow(false);
    setShowLeave(false);
    setShowReapply(false);
    setSelectedRow(null);
    setEditDescription("");
    setExistingAttachments([]);
    setAttachmentsToRemove([]);
    setNewAttachments([]);
  };

  const handleShowLeave = (leave) => {
    setSelectedRow(leave);
    setShowLeave(true);
  };

  const handleShowReapply = (leave) => {
    setSelectedRow(leave);
    setEditDescription(leave[7] || "");
    setExistingAttachments((leave[10] || []).map(att => ({ ...att })));
    setShowReapply(true);
  };

  const fetchLeaves = async () => {
    try {
      const secretKey = configData.SECRET_Key;
      const requestData = { employee_id, secretKey };
      const response = await fetch(`${configData.SERVER_URL}/myleaves`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();      
      const result = JSON.parse(data.result);
      if (result.success === true) {
        setLeaves(result.leaves);
        setLoading(false);
      } else {
        console.log("result ===", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
  }, []);

  useEffect(() => {
    fetchLeaves();
  }, [employee_id]);

  const [fetchleave, setFetchleave] = useState(false);
  
  const handleUpload = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (fetchleave) return;
    setFetchleave(true); 
    try {
      const secretKey = configData.SECRET_Key;
      const requestData = { formData, employee_id, secretKey, leave_id: selectedRow[8] };
      const response = await fetch(`${configData.SERVER_URL}/addDocument`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error("Failed to create leave");
      }
      if (response) {
        const data = await response.json();
        const result = parseLeaveResult(data);
        if (result.success === true) {
          window.location.reload();
        } else {
          showLeaveError(result.message);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      showLeaveCatch(error);
    } finally {
      setFetchleave(false);
    }
  };

  const handleNewAttachmentsChange = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const base64DataArray = [];
    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        base64DataArray.push({
          name: file.name,
          mimetype: file.type || (file.name.endsWith('.pdf') ? 'application/pdf' : 'application/octet-stream'),
          datas: reader.result
        });
        if (base64DataArray.length === files.length) {
          setNewAttachments(prev => [...prev, ...base64DataArray]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const markRemoveExistingAttachment = (attId) => {
    setAttachmentsToRemove(prev => {
      if (prev.includes(attId)) return prev;
      return [...prev, attId];
    });
    setExistingAttachments(prev => prev.filter(a => a.id !== attId));
  };

  const removeNewAttachment = (index) => {
    setNewAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const handleReapplySubmit = async () => {
    if (fetchleave) return;
    setFetchleave(true);
    try {
      const secretKey = configData.SECRET_Key;
      const payload = {
        leave_id: selectedRow[8],
        employee_id,
        secretKey,
        description: editDescription,
        attachments_to_remove: attachmentsToRemove,
        attachments_to_add: newAttachments,
      };

      const response = await fetch(`${configData.SERVER_URL}/reapply_leave`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network response not ok");

      const data = await response.json();
      let result = parseLeaveResult(data);

      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Leave reapplied successfully!'
        });
        handleClose();
        fetchLeaves();
      } else {
        showLeaveError(result.message || 'Failed to reapply');
      }
    } catch (error) {
      console.error("Error:", error);
      showLeaveCatch(error);
    } finally {
      setFetchleave(false);
    }
  };

  const handleChange = (e) => {
    const { name, checked, files, value } = e.target;
    if (e.target.name === "attachment") {
      const base64DataArray = [];
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          base64DataArray.push(reader.result);
          if (base64DataArray.length === files.length) {
            setFormData({ ...formData, [name]: base64DataArray });
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  return (
    <>
      {load ? (
        <LoadingComponent />
      ) : (
        <div className="status_table">
          <table className="leave_status_table">
            <thead>
              <tr style={{ background: textColor }}>
                <th>S.NO</th>
                <th>LEAVE TYPE</th>
                <th>DATE FROM</th>
                <th>DATE TO</th>
                <th>DURATION</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {leaves.map((leave, index) => (
              <tr
                key={index}
                role="button"
                onClick={(e) => {
                  handleShowLeave(leave);
                }}
                style={leave[11] === 1 ? { 
                  backgroundColor: '#e6f3ff', 
                  borderLeft: '4px solid #1890ff' 
                } : {}}
              >
                <td style={leave[11] === 1 ? { backgroundColor: '#e6f3ff' } : {}}>{index + 1}</td>
                <td style={leave[11] === 1 ? { backgroundColor: '#e6f3ff' } : {}}>{leave[0]}</td>
                <td style={leave[11] === 1 ? { backgroundColor: '#e6f3ff' } : {}}>{leave[1]}</td>
                <td style={leave[11] === 1 ? { backgroundColor: '#e6f3ff' } : {}}>{leave[2]}</td>
                <td style={leave[11] === 1 ? { backgroundColor: '#e6f3ff' } : {}}>{leave[3]}</td>
                <td style={leave[11] === 1 ? { backgroundColor: '#e6f3ff' } : {}}>
                  <span className={
                        leave[4] === "Approved"
                          ? "op_a"
                          : leave[4] === "Pending"
                          ? "op_p"
                          : leave[4] === "AL-Rejected"
                          ? "op_al"
                          : "op_r"
                      }>
                    {leave[4]}
                  </span>
                  {leave[11] === 1 && (
                    <Button
                        style={{ marginLeft: "10px" }}
                        variant="primary"
                        size="sm"
                        onClick={(ev) => { ev.stopPropagation(); handleShowReapply(leave); }}
                      >
                      Reapply
                    </Button>
                  )}
                </td>
              </tr>
              ))}
            </tbody>
          </table>

          {/* Existing Leave Info Modal (unchanged) */}
          <Modal
            show={showleave}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            className="leave-info-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {selectedRow && selectedRow[0]}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="grid-example">
              <Container>
                <Row>
                  <Col xs={6} md={5}>{selectedRow && selectedRow[12] ? "Date" : "Dates"}</Col>
                  <Col xs={6} md={7}>
                    {selectedRow && selectedRow[12] ? (
                      <span>From {selectedRow[1]}</span>
                    ) : (
                      <span>From {selectedRow && selectedRow[1]} To {selectedRow && selectedRow[2]}</span>
                    )}
                  </Col>
                </Row>
                {selectedRow && selectedRow[12] ? (
                  <Row>
                    <Col xs={6} md={5}>Hours</Col>
                    <Col xs={6} md={7}>{selectedRow[13]} - {selectedRow[14]}</Col>
                  </Row>
                ) : null}
                <Row>
                  <Col xs={6} md={5}>Duration</Col>
                  <Col xs={6} md={7}>{selectedRow && selectedRow[3]}</Col>
                </Row>
                <Row>
                  <Col xs={6} md={5}>Description</Col>
                  <Col xs={6} md={7}>{selectedRow && selectedRow[7]}</Col>
                </Row>
                <Row>
                  <Col xs={6} md={5}>Status</Col>
                  <Col xs={6} md={7}>
                    {selectedRow && (
                      <span
                        className={
                          selectedRow[4] === "Approved"
                            ? "op_a"
                            : selectedRow[4] === "Pending"
                            ? "op_p"
                            : "op_r"
                        }
                      >
                        {selectedRow[4]}
                      </span>
                    )}
                  </Col>
                </Row>
                {selectedRow && selectedRow[10] && selectedRow[10].length > 0 && (
                  <Row className="mt-3">
                    <Col xs={6} md={5}>Attachments</Col>
                    <Col xs={6} md={7}>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {selectedRow[10].map((attachment, index) => (
                          <div key={index} style={{ marginBottom: '15px', width: '150px' }}>
                            {attachment.mimetype.startsWith('image/') ? (
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ marginBottom: '5px' }}>
                                  <Image size={24} />
                                </div>
                                <div style={{ marginTop: '5px', wordBreak: 'break-word', fontSize: '12px' }}>
                                  {attachment.name}
                                </div>
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center' }}>
                                {attachment.mimetype === 'application/pdf' ? (
                                  <FileEarmarkPdf size={32} style={{ color: '#e74c3c' }} />
                                ) : (
                                  <FileEarmarkText size={32} />
                                )}
                                <div style={{ marginTop: '5px', wordBreak: 'break-word', fontSize: '12px' }}>
                                  {attachment.name}
                                </div>
                              </div>
                            )}
                            <div style={{ textAlign: 'center', marginTop: '5px' }}>
                              <a
                                href={`data:${attachment.mimetype};base64,${attachment.datas}`}
                                download={attachment.name}
                                style={{ fontSize: '12px', color: '#3498db', textDecoration: 'none' }}
                              >
                                <Download size={14} style={{ marginRight: '5px' }} />
                                Download
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col xs={6} md={5}>Add Document</Col>
                  <Col xs={6} md={7}>
                    <input
                      type="file"
                      id="attachment"
                      name="attachment"
                      accept=".pdf, image/*"
                      onChange={handleChange}
                      multiple
                    />
                  </Col>
                </Row>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose}>Close</Button>
              <Button onClick={handleUpload}>Upload</Button>
            </Modal.Footer>
          </Modal>

          {/* NEW: Reapply Modal in the format of Apply Leave Modal */}
          {showReapply && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              onClick={handleClose}
            >
              <div
                className="modal-dialog"
                style={{ maxWidth: 750 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  className="modal-content"
                  style={{ backgroundColor: "#fff" }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Reapply Leave
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleClose}
                    />
                  </div>
                  <div className="modal-body o_form_view">
                    <table className="tb-view">
                      <tbody className="tb_body_content">
                        <tr className="td_leave">
                          <td className="htd">Leave Type</td>
                          <td style={{ width: "100%", position: "relative" }}>
                            <div className="">
                              <input
                                type="text"
                                value={selectedRow && selectedRow[0]}
                                readOnly
                                style={{ width: "100%", padding: "8px", background: "#f8f9fa" }}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr className="td_leave">
                          <td className="htd">Dates</td>
                          <td style={{ width: "100%" }}>
                            <div className="divhtd" style={{ justifyContent: "space-between" }}>
                              <span className="htds">From </span>
                              <input
                                type="text"
                                value={selectedRow && selectedRow[1]}
                                readOnly
                                style={{ width: "120px", padding: "8px", background: "#f8f9fa" }}
                              />
                              <span className="htds pl-2">To </span>
                              <input
                                type="text"
                                value={selectedRow && selectedRow[2]}
                                readOnly
                                style={{ width: "120px", padding: "8px", background: "#f8f9fa" }}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr className="td_leave">
                          <td className="htd">Duration</td>
                          <td style={{ width: "100%" }}>
                            <input
                              type="text"
                              value={selectedRow && selectedRow[3]}
                              readOnly
                              style={{ width: "100%", padding: "8px",  background: "#f8f9fa" }}
                            />
                          </td>
                        </tr>
                        <tr className="td_leave">
                          <td className="htd">Description</td>
                          <td style={{ width: "100%" }}>
                            <textarea
                              value={editDescription}
                              onChange={(e) => setEditDescription(e.target.value)}
                              rows="4"
                              style={{ width: "100%", padding: "8px" }}
                              placeholder="Enter your reason for reapplying..."
                            />
                          </td>
                        </tr>
                        
                        {/* Existing Attachments */}
                        {existingAttachments.length > 0 && (
                          <tr className="td_leave">
                            <td className="htd">Existing Attachments</td>
                            <td style={{ width: "100%" }}>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {existingAttachments.map((att, idx) => (
                                  <div key={att.id || idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px', borderRadius: '4px' }}>
                                    {att.mimetype && att.mimetype.startsWith('image/') ? <Image size={18} /> :
                                      att.mimetype === 'application/pdf' ? <FileEarmarkPdf size={18} /> : <FileEarmarkText size={18} />}
                                    <div style={{ flex: 1, fontSize: '13px', wordBreak: 'break-all' }}>{att.name}</div>
                                    <Button variant="outline-danger" size="sm" onClick={() => markRemoveExistingAttachment(att.id)}>
                                      <Trash size={14} /> Remove
                                    </Button>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        )}

                        {/* New Attachments */}
                        <tr className="td_leave">
                          <td className="htd">Add Attachments</td>
                          <td style={{ width: "100%", textAlign: "left" }}>
                            <input
                              type="file"
                              id="new_attachment"
                              name="new_attachment"
                              accept=".pdf, image/*"
                              onChange={handleNewAttachmentsChange}
                              multiple
                              style={{ width: "100%", padding: "8px" }}
                            />
                            <div style={{ marginTop: '8px' }}>
                              {newAttachments.map((n, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', padding: '4px', background: '#f8f9fa', borderRadius: '4px' }}>
                                  <div style={{ flex: 1, fontSize: '13px', wordBreak: 'break-all' }}>{n.name}</div>
                                  <Button variant="outline-danger" size="sm" onClick={() => removeNewAttachment(i)}>
                                    <Trash size={12} /> Remove
                                  </Button>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-primary"
                      onClick={handleReapplySubmit}
                      disabled={fetchleave}
                    >
                      {fetchleave ? 'Reapplying...' : 'Reapply'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default LeaveTable;